// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_container__LOX6d {
  display: flex;
  justify-content: space-between;
  padding: 0.5em 0;
}

.header_title__OBO6A {
  font-family: 'IBM Plex Sans', sans-serif;
  margin-top: 45px;
  font-weight: 600;
  font-size: 24px;
  color: black !important;
  text-align: left;
}

.header_search__6-kmX {
  margin-top: 45px;

  .header_searchInput__rNQ3V {
    text-align: left;
    width: 300px;
    padding: 8px 2px;
    border-radius: 8px;
    /* height: 50px; */
  }

  .header_searchIcon__HgKGA {
    color: black !important;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5em 0;\n}\n\n.title {\n  font-family: 'IBM Plex Sans', sans-serif;\n  margin-top: 45px;\n  font-weight: 600;\n  font-size: 24px;\n  color: black !important;\n  text-align: left;\n}\n\n.search {\n  margin-top: 45px;\n\n  .searchInput {\n    text-align: left;\n    width: 300px;\n    padding: 8px 2px;\n    border-radius: 8px;\n    /* height: 50px; */\n  }\n\n  .searchIcon {\n    color: black !important;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `header_container__LOX6d`,
	"title": `header_title__OBO6A`,
	"search": `header_search__6-kmX`,
	"searchInput": `header_searchInput__rNQ3V`,
	"searchIcon": `header_searchIcon__HgKGA`
};
export default ___CSS_LOADER_EXPORT___;
